import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningAdminModuleSeriesGridList from '../components/LearningAdminModuleSeriesGridList';
import {
  loadModuleSeriesAdmin,
  patchModuleSerieAdmin,
  deleteModuleSerieAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';
import storage from '../../../../../lib/Storage';
import store from '../../../../../state/store';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 20;
const defaultOrder = 'order.asc';
const defaultScope = 'list';

const mapStateToProps = (state, ownProps) => {
  const action = ownProps.action;

  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all module series
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learningsAdmin.getIn(
        [
          'moduleSeriesAdmin',
          defaultScope,
          partnershipId,
          action,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModuleSeriesAdmin', x]),
              schema.learningModuleSerieAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    list,
    action,
    partnershipId,
    defaultLimit,
    defaultOrder,
    defaultScope,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      action,
      filter = {},
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      scope = defaultScope,
      cb = function () {}
    ) => {
      dispatch(
        loadModuleSeriesAdmin(
          partnershipId,
          action,
          filter,
          page,
          limit,
          order,
          scope,
          (success, total, result) => {
            if (success && result) {
              const state = store.getState();

              const normalizedResult = result.map((x) => {
                return {
                  key: x,
                  ...denormalize(
                    state.entities.getIn(['learningModuleSeriesAdmin', x]),
                    schema.learningModuleSerieAdmin,
                    state.entities.toJS()
                  ),
                };
              });

              const pageCount = Math.ceil(total / limit);
              for (let i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleSeriesAdmin(
                    partnershipId,
                    action,
                    filter,
                    i,
                    limit,
                    order,
                    scope
                  )
                );
              }

              cb(true, normalizedResult);
            } else {
              cb(false, null);
            }
          }
        )
      );
    },
    patch: (partnershipId, id, data, cb) => {
      dispatch(patchModuleSerieAdmin(partnershipId, id, data, cb));
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleSerieAdmin(partnershipId, id, cb));
    },
  };
};

const LearningAdminModuleSeriesGridListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSeriesGridList);

export default LearningAdminModuleSeriesGridListContainer;
